import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { AuthorizerService } from '../authorizers.service';
import * as authorizerActions from './authorizers.actions';

@Injectable({
    providedIn: 'root'
})

export class AuthorizerEffects {


    fetchMerchantAuthorizers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authorizerActions.fetchMerchantAuthorizers),
      exhaustMap((action) =>
        this.authorizerService
          .getMerchantAuthorizers()
          .pipe(
            exhaustMap((response: any) => [
                authorizerActions.fetchMerchantAuthorizersSuccess({ authorizers: response.data }),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(authorizerActions.fetchMerchantAuthorizersFailed())
            }
            )
          )
      )
    )
  );


    createAuthorizer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authorizerActions.createAuthorizer),
      exhaustMap((action) =>
        this.authorizerService
          .createMerchantAuthorizer(action.authorizerDto)
          .pipe(
            exhaustMap((response: any) => [
                authorizerActions.createAuthorizerSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(authorizerActions.createAuthorizerFailed())
            }
            )
          )
      )
    )
  );
    deleteAuthorizer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authorizerActions.deleteAuthorizer),
      exhaustMap((action) =>
        this.authorizerService
          .deleteMerchantAuthorizer(action.authorizerID)
          .pipe(
            exhaustMap((response: any) => [
                authorizerActions.deleteAuthorizerSuccess(),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(authorizerActions.deleteAuthorizerFailed())
            }
            )
          )
      )
    )
  );

    constructor(
        private actions$: Actions,
        private authorizerService: AuthorizerService,
        private toastr: ToastrService
    ) {}
}
